// OAuth / API config the auth data-layer needs outside React (plain client functions can't call
// hooks). Seeded once at boot from the backend app-state blob (`app.oauth` + `app.domains.api`) via
// `configureAuth`, mirroring how `configureHttpClient` receives the API base URL. Values come from
// backend env (`OAUTH_GOOGLE_CLIENT_ID`, the web OAuth2 client creds) — see MI2-2038 backend track.

export type TAuthConfig = {
    /** OAuth2 client_id of the audio.com web client (League client). */
    clientId: string
    /** Its client_secret (public client secret; audio-web exposed it as NEXT_PUBLIC_CLIENT_SECRET). */
    clientSecret: string
    /** Google GSI client id for One Tap — the backend `OAUTH_GOOGLE_CLIENT_ID` audience. */
    googleClientId: string
    /** Absolute SPA OAuth callback URL registered with the backend/providers. */
    redirectUri: string
    /** API origin (`app.domains.api`) — base for the `auth/authorize` redirect URL. */
    apiBaseUrl: string
    /** `authclient` to send instead of the real provider; set by the backend, local development only. */
    providerOverride: string
}

let config: TAuthConfig = {
    clientId: '',
    clientSecret: '',
    googleClientId: '',
    redirectUri: '',
    apiBaseUrl: '',
    providerOverride: '',
}

export const configureAuth = (next: Partial<TAuthConfig>) => {
    config = { ...config, ...next }
}

export const getAuthConfig = (): TAuthConfig => config
